import type { ReactNode } from 'react';

import { cssClasses } from 'pkg/css/utils';

import * as css from './styles.css';

interface Props {
	children: ReactNode;
	lineThrough?: boolean;
}

/**
 * Label component
 *
 * A simple styled label wrapper for form elements.
 */

export function Label({ children, lineThrough }: Props) {
	return (
		<label
			className={cssClasses(css.label, lineThrough ? css.lineThrough : '')}>
			{children}
		</label>
	);
}
